import React, { useContext } from "react";
import { Copy, Info } from "lucide-react";
import { ErrorModalContext } from "../../../AlertsModal/AlertsModal";
import ToolTip from "../../../ToolTip/ToolTip";
import { CopyableInputProps } from "../interfaces";

export const CopyableInput: React.FC<CopyableInputProps> = (props) => {
  const { isRequired, label, tooltipText, value } = props;
  const { showAlert } = useContext(ErrorModalContext);

  const copyValue = (): void => {
    if (navigator && navigator.clipboard && value) {
      navigator.clipboard.writeText(value.toString());
      showAlert(
        `${label || "Valor"} copiado correctamente`,
        "success",
        "Copiado al portapapeles",
      );
    }
  };

  return (
    <div className="flex w-full flex-col gap-2">
      {label && (
        <div className="flex items-center gap-2">
          <label className="text-sm font-normal text-gray-500">
            {label}{" "}
            {isRequired && (
              <span className="text-xs font-normal text-gray-500">*</span>
            )}
          </label>
          {tooltipText && (
            <ToolTip text={tooltipText}>
              <Info className="h-3 w-3 shrink-0 text-gray-500" />
            </ToolTip>
          )}
        </div>
      )}
      <div className="relative">
        <input
          type="text"
          className="h-10 w-full rounded-md border border-gray-200 bg-white px-3 py-2 pr-9 text-sm placeholder:text-gray-500 focus:outline-none disabled:bg-gray-300/20 disabled:text-gray-500 disabled:opacity-100"
          value={value}
          disabled={true}
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
          <Copy
            className="h-4 w-4 cursor-pointer text-gray-500"
            onClick={copyValue}
          />
        </div>
      </div>
    </div>
  );
};
